import { FontEntry } from '../../types/font'

export const sailec: FontEntry = {
  displayName: 'Sailec',
  weights: {
    100: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Hairline',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Hairline Italic',
        extension: 'otf',
        format: 'opentype'
      }
    },
    200: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Thin',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Thin Italic',
        extension: 'otf',
        format: 'opentype'
      }
    },
    300: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Light',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Light Italic',
        extension: 'otf',
        format: 'opentype'
      }
    },
    400: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Regular',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Regular Italic',
        extension: 'otf',
        format: 'opentype'
      }
    },
    500: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Medium',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Medium Italic',
        extension: 'otf',
        format: 'opentype'
      }
    },
    700: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Bold',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Bold Italic',
        extension: 'otf',
        format: 'opentype'
      }
    },
    900: {
      normal: {
        file: 'Type+Dynamic+-+Sailec+Black',
        extension: 'otf',
        format: 'opentype'
      },
      italic: {
        file: 'Type+Dynamic+-+Sailec+Black Italic',
        extension: 'otf',
        format: 'opentype'
      }
    }
  }
}
